import React from "react";
import { useTranslation } from "react-i18next";
import logo from "./pru-logo-full.png";
import PlaiFooter from "../plai-footer/plai-footer";

export const PlaiErrorScreen: React.FC<{ withFooter: boolean }> = ({ withFooter = false }) => {
  const { t } = useTranslation();
  window.document.title = t("error-state.title-403");
  return (
    <div className="flex flex-col w-full min-h-screen overflow-x-hidden">
      <div className="p-10 m-auto">
        <img className="w-48 h-auto" alt="logo" src={logo} />
        <div className="sm:text-4xl text-3xl font-semibold mt-5 mb-2">
          {t("error-state.title-arl")}
        </div>
        <div className="sm:text-xl text-lg leading-5">{t("error-state.desc-arl")}</div>
      </div>
      {withFooter && <PlaiFooter content={t("default-footer-text")} />}
    </div>
  );
};
